import { createBrowserRouter, Navigate, useLocation, type RouteObject } from 'react-router-dom'
import { Shell } from './Shell'
import { NotFound } from './NotFound'
import { RouteError } from './RouteError'
import { moved } from './paths'

// Every role ships web/src/features/<role>/routes.tsx exporting `routes: RouteObject[]` with absolute
// paths ("/team", "/partner/rules", ...). No shared route list: the glob picks them all up.
const modules = import.meta.glob<{ routes: RouteObject[] }>('../features/*/routes.tsx', { eager: true })

export function featureRoutes(): RouteObject[] {
  return Object.keys(modules)
    .sort()
    .flatMap((file) => modules[file].routes ?? [])
}

// Founder, 2026-11-04: the company pages left /app for the root. Every old /app/... link (emails, ernd.io buttons,
// bookmarks) opens its new page, query and #hash kept; the table is in ./paths.ts. The server 301s these too when it
// serves the page, so this catches links followed inside the app and the dev server.
function OldAppPath() {
  const { pathname, search, hash } = useLocation()
  return <Navigate to={(moved(pathname + search) ?? '/') + hash} replace />
}

export const GONE: RouteObject[] = ['/app', '/app/*'].map((path) => ({ path, element: <OldAppPath /> }))

export function makeRouter() {
  return createBrowserRouter([
    {
      path: '/',
      element: <Shell />,
      errorElement: <RouteError />,
      children: [...featureRoutes(), ...GONE, { path: '*', element: <NotFound /> }],
    },
  ])
}
